import { useQuery } from '@tanstack/react-query';
import { api, GrRewardTypeLimitResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseRewardTypeLimitsReturn {
  limits: GrRewardTypeLimitResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useRewardTypeLimits(): UseRewardTypeLimitsReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.rewardTypeLimits(),
    queryFn: () => api.listGameRewardsLimits(),
  });

  return {
    limits: data?.limits ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error:
      error instanceof Error ? error.message : isError ? 'Failed to load reward type limits' : null,
    refresh: () => {
      refetch();
    },
  };
}
